module.exports = __webpack_public_path__ + "static/img/8.df1c9a7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/2/zh/8.png
// module id = Kfhs
// module chunks = 0